import React from 'react';

interface ChevronIconProps {
    width?: number;
    height?: number;
    fill?: string;
}

const ChevronIcon = ({
    width = 28,
    height = 28,
    fill = '#191C21',
}: ChevronIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22.3198 17.6752C22.325 17.9127 22.2562 18.1459 22.1227 18.3425C21.9893 18.539 21.7978 18.689 21.5751 18.7718C21.3525 18.8545 21.1096 18.8658 20.8802 18.8041C20.6508 18.7424 20.4464 18.6108 20.2953 18.4275L14.3042 11.4342L8.31529 18.4275C8.22211 18.5543 8.1038 18.6604 7.96768 18.7394C7.83156 18.8183 7.68057 18.8683 7.52424 18.8861C7.36792 18.904 7.20961 18.8894 7.05918 18.8433C6.90875 18.7972 6.76943 18.7205 6.65002 18.618C6.5306 18.5155 6.43374 18.3895 6.36529 18.2478C6.29683 18.1062 6.25838 17.9519 6.25232 17.7946C6.24625 17.6374 6.27262 17.4806 6.32996 17.3341C6.38729 17.1876 6.47426 17.0545 6.58542 16.9431L13.436 8.9364C13.5433 8.81067 13.6764 8.7097 13.8265 8.64047C13.9766 8.57124 14.14 8.53538 14.3053 8.53538C14.4706 8.53538 14.634 8.57124 14.7841 8.64047C14.9342 8.7097 15.0675 8.81067 15.1748 8.9364L22.0319 16.9431C22.2116 17.1454 22.3137 17.4048 22.3201 17.6752H22.3198Z"
                fill={fill}
            />
        </svg>
    );
};

export default ChevronIcon;
